import Icon from '@loggi/ui/components/icon';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import View from '@loggi/ui/components/view';
import React from 'react';
import styles from './covid19-message.styles.scss';

export const COVID19_MESSAGE_TITLE = 'Covid19:';
const COVID19_MESSAGE_CONTEXT =
  'veja como receber seu pacote de forma segura, ';
export const COVID19_MESSAGE_LINK_LABEL = 'clique aqui.';

const Covid19Message = () => {
  return (
    <View className={styles.covid19}>
      <Icon type={icons.type.INFO} color={colors.type.STORM_700} />
      <Text color={colors.type.SMOKE_700} size="200">
        <Text color={colors.type.SMOKE_700} bold size="200">
          {COVID19_MESSAGE_TITLE}
        </Text>{' '}
        {COVID19_MESSAGE_CONTEXT}
        <a
          href="https://ajuda.loggi.com/hc/pt-br/articles/360041831091"
          target="_blank"
          rel="noopener noreferrer"
        >
          {COVID19_MESSAGE_LINK_LABEL}
        </a>
      </Text>
    </View>
  );
};

export default Covid19Message;
